import React, { useState, FunctionComponent } from 'react';
import { navigate } from '@reach/router';
import { ChangePasswordForm, SuccessComponent } from '../changePassword/ChangePassword';
import { changePassword } from '@v10-codeparva/v10-tfw-revamp-package-api';
import { Spinner } from '@chakra-ui/react';
import { useCookie } from 'utils/auth';
import { localisable } from '../../../generic/localisable';

const navigateTo = (route: string) => {
    const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
    const pathSegments = currentPath.split('/');
    // Keep only the segments up to and including "pay-rent"
    const basePath = pathSegments.slice(0, pathSegments.indexOf('pay-rent') + 1).join('/');
    navigate(`${basePath}/${route}`);
}

export const ResetPassword: FunctionComponent<any> = ({ location }: any) => {
    const [isSuccess, setIsSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [_, setCToken] = useCookie('cToken');
    const [cpError, setCpError] = useState('');

    const {
        state: {
            token
        }
    } = location;


    const onSubmitCpLoginForm = async (formData: any) => {
        setIsLoading(true)
        const changePasswordRequest = {
            strOldPassword: formData.oldPassword,
            strNewPassword: formData.newPassword,
            confirmPassword: formData.reEnterNewPassword,
            token,
            cid: process.env.CID || '',
        };

        changePassword(changePasswordRequest).then((changePasswordApiResponse) => {
            setCpError('');
            const { blnSuccess } = changePasswordApiResponse;
            setIsLoading(false);
            if (blnSuccess) {
                setIsSuccess(blnSuccess);
            }
            else {
                setCpError(localisable.credentialsError);
            }
        }).catch((error) => {
            if (error.response) {
                console.log(error.response.data); // => the response payload 
            }
            setCpError(localisable.credentialsError);
        })
    };

    const goToPaymentRouteHandler = () => {
        setCToken(token);
        navigateTo('payment')
    };


    const RenderComponent = () => {
        if (isSuccess) {
            return <SuccessComponent
                note='Password successfully changed.'
                customerNote=''
                goToPaymentHandler={goToPaymentRouteHandler}
            />
        }
        return <ChangePasswordForm
            changePasswordError={cpError}
            onSubmitChangePasswordForm={onSubmitCpLoginForm}
        />
    };

    const RenderLoader = () => {
        if (isLoading) {
            return <Spinner size={'xl'} />
        }
        return <RenderComponent />
    }

    return (
        <>
            <RenderLoader />
        </>
    )
};